module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-card"
  }, [_c('h1', [_vm._v("产品详情")]), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "title-box"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "content-box"
    }, [_vm._v(_vm._s(item.content))])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6bc784fd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6bc784fd"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/pack/detail-card.vue
// module id = 1077
// module chunks = 1